<template>
<v-card>
  <request-status
    :request='request'
    :message200='false'
    :message401='null'
    message404="Could not find a matching incoming notification from JotForm - some fields may not be formatted correctly" />
  <v-card-title class='py-1 overline grey lighten-4' >
    <v-btn small icon
      :loading="request.loading"
      @click="getSubmission" ><v-icon small>replay</v-icon>
    </v-btn>
    Submission:
    <v-spacer></v-spacer>

    <!-- <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon small :href='pdfLink' target='_blank' >
          <v-icon small>download</v-icon>
        </v-btn>
      </template>
      <span>Download the pdf from JotForm</span>
    </v-tooltip>
    <v-btn icon small :href='viewLink' target='_blank' >
      <v-icon small>open_in_new</v-icon>
    </v-btn> -->

    <v-btn small icon
      v-if="withClose"
      @click="$emit('close')" ><v-icon>close</v-icon>
    </v-btn>

  </v-card-title>
  <!-- <pre v-text="request" /> -->
  <v-alert :value="request.status === 401" text >
    Unable to fetch this response from JotForm (permission denied).
    Have you uninstalled the integration or changed your API key?
    <a href="" >Open submission in JotForm</a>
  </v-alert>

  <!-- <pre v-text='submission' /> -->
  <v-card v-if='submission && submission.id' >
    <v-card-title class="overline" >
      Answers
      <v-spacer />

      <v-btn small flat :href="submissionLink" v-if="submissionLink" target="_blank" >
        Open in JotForm
      </v-btn>
      <!-- open in jotform -->
    </v-card-title>
    <v-divider/>
    <template v-for='(answer, index) in submission.answers' >
      <template v-if='answer.answer' >
        <v-card flat :key='`${submission.id}-${answer.name}`' >
          <v-subheader v-if="answer.type === 'control_head'" >{{answer.text}}</v-subheader>
          <v-divider v-if="answer.type === 'control_divider'" />

          <v-card-text v-if="answer.answer" class="py-1 px-3" >
            <template v-if="answer.type === 'control_signature'" >
              <v-subheader class="overline" >Signature:</v-subheader><br/>
              <img :src="getRawAnswer(index, answer)" />
              <div v-if="answer.prettyFormat" v-html="sanitize(answer.prettyFormat)" />
            </template>
            <template v-if="answer.type === 'control_fileupload'" >
              <!-- <v-subheader class="overline" >Files: {{answer.name}}</v-subheader><br/>
              <a v-for="url in answer.answer"
                :key="getUploadProxy(url)"
                :href="getUploadProxy(url)"
                target="_blank" >

                <v-img :src="getUploadProxy(url)"
                  max-width="300" max-height="300"
                  class="elevation-3 mb-2" />

                 <v-img :src="url"
                  max-width="300" max-height="300"
                  class="elevation-3 mb-2" />

              </a> -->
              <strong>{{answer.text}}</strong>
              <div v-if="answer.prettyFormat" v-html="sanitize(answer.prettyFormat)" />
            </template>
            <template v-else >
              <strong>{{answer.text}}</strong>
              <div v-if="answer.prettyFormat" v-html="sanitize(answer.prettyFormat)" />
              <div v-else>{{answer.answer}}</div>
            </template>
            <!-- <pre v-text="answer" /> -->

          <!-- <v-list-tile-action v-if='answer.type === "control_signature"' >
            <v-btn small icon :href='answer.answer' target='_blank' ><v-icon small >open_in_new</v-icon></v-btn>
          </v-list-tile-action> -->
          </v-card-text>
        </v-card>
        <v-divider
          v-if='answer.answer'
          :key="`div-${submission.id}-${answer.name}-${index}`" />
      </template>
    </template>
    <v-card-actions >
      <v-btn @click="$emit('close')" flat >Done</v-btn>
    </v-card-actions>
  </v-card>
</v-card>
</template>
<script>
import * as DOMPurify from 'dompurify'

export default {
  name: 'FormSubmissionCard',
  props: {
    submissionId: { required: false },
    value: { type: Object, default: () => {} },
    visible: { type: Boolean, default: false },
    withClose: { type: Boolean, default: false }
  },
  data () {
    return {
      request: {
        resource: 'ag.integrations',
        extra: 'jotform/submission',
        result: null
      }
    }
  },
  // computed: {
  //   submission () {
  //     return this.request.data
  //   }
  // },
  watch: {
    submissionId: {
      immediate: true,
      handler () {
        if (this.submissionId) {
          this.getSubmission()
        }
      }
    },
    visible () {
      if (this.visible && this.submissionId) {
        this.getSubmission()
      }
    },
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.submission = this.value
        }
      }
    },
    requestStatus () {
      if (this.requestStatus === 200) {
        this.submission = this.request.result.content
      }
    }
  },
  computed: {
    requestStatus () {
      return this.request.status
    },
    submissionLink () {
      if (this.submission.form_id && this.submission.id) {
        return `https://jotform.com/inbox/${this.submission.form_id}/${this.submission.id}`
      }
      return null
    }
  },
  methods: {
    getSubmission () {
      this.request.extra = `jotform/${this.submissionId}/submission`
      // this.request.extra = `jotform/5039222729458223561/submission`
      this.$request('get', this.request)
    },
    getRawAnswer (index, answer) {
      let key = `q${index}_${answer.name}`
      // return this.submission
      return this.getObjectPath(this.request, `result.linked_submission.raw_data.${key}`)
    },
    getUploadProxy (url) {
      let base = this.$appointmentguru.baseUrl
      let u = encodeURI(url)
      return `${base}/api/v2/practitioner/integrations/jotform/image/?url=${u}`
    },
    sanitize (txt) {
      return DOMPurify.sanitize(txt, { USE_PROFILES: { html: true } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormSubmissionCard.vue?59aca706